import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { injectIntl } from "react-intl";
import { ToastContainer, toast } from "react-toastify";
import { Grid2 as Grid } from "@mui/material";
import { notificationCodes } from "../../../modules/notification";
import { closeEncounterNotification, getEncounterUpdateNotification, NOTIFICATIONS_TIMESTAMP_FORMAT } from "../../../modules/tracking";
import { getMessageString } from "../../../utility";

const TOAST_CONTAINER = "encounterNotificationToastContainer";

export const EncounterNotification = injectIntl(({ intl }) => {
  const dispatch = useDispatch();
  const updateNotification = useSelector(getEncounterUpdateNotification);

  const accessibilityFix = () => {
    setTimeout(() => {
      const toastsBody = document.getElementsByClassName("Toastify__toast-body");
      if (toastsBody.length > 0) {
        for (let i = 0; i < toastsBody.length; i++) {
          toastsBody[i].removeAttribute("role");
        }
      }
    }, [100]);
  };

  const NotificationContent = () => (
    <Grid container spacing={1}>
      <Grid size={12} sx={{ fontWeight: 600 }} className="encounterNotificationTitle">
        {updateNotification.timestamp.format(NOTIFICATIONS_TIMESTAMP_FORMAT)}
      </Grid>
      {updateNotification.changes.map((changes, index) => (
        <Grid size={12} sx={{ fontSize: "1rem" }} key={index} className="encounterNotificationTitle">
          {getMessageString(intl, changes)}
        </Grid>
      ))}
    </Grid>
  );

  useEffect(() => {
    if (updateNotification) {
      const notificationId = updateNotification.timestamp.unix();
      toast(<NotificationContent />, {
        position: "bottom-right",
        theme: "colored",
        autoClose: false,
        onOpen: accessibilityFix(),
        onClose: () => dispatch(closeEncounterNotification(notificationId)),
        type: notificationCodes.INFO,
        containerId: TOAST_CONTAINER,
        toastId: notificationId,
      });
    } else toast.dismiss();
    // eslint-disable-next-line
  }, [updateNotification]);

  return <ToastContainer containerId={TOAST_CONTAINER} newestOnTop={true} style={{ zIndex: 10 }} draggable />;
});
